module.exports = __webpack_public_path__ + "static/media/help-tile-03@3x.abc1de22.png";